import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import myArtistsReducer from '../reducers/myArtistsReducer';

const configureStore = (railsProps) => (
  createStore(myArtistsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
